import OnlineFactorCreateItems  from './Create_item'
import OnlineFactorGetItems from './GetItems'
import OnlineFactorShow from './Showitem'
import OnlineFactorShowCustomer from './ShowCustomer'
import OnlineFactorCustomers from './Customers'
import OnlineFactorCreateCustomer from './Create_customer'
import OnlineFactorGetFactor  from './Facotrs'
import OnlineFactorCreateFactor from './Create_Factor'
import OnlineFactorShowFactor from './ShowFactor'
import OnlineFactorPayment from './components/factor-payment'


export {
    OnlineFactorCreateItems,
    OnlineFactorGetItems,
    OnlineFactorShow,
    OnlineFactorCustomers,
    OnlineFactorCreateCustomer,
    OnlineFactorShowCustomer,
    OnlineFactorGetFactor,
    OnlineFactorCreateFactor,
    OnlineFactorShowFactor,
    OnlineFactorPayment
}